import React, { useEffect, useState } from "react";
import "../styles/group-membership.scss";
import { SettingsApi } from "../actions/settings-action";
import { useOnFirstLoad } from "../utilities/hooks";
import CircularProgress from "../actions/CircularProgress";
import navigate from "../utilities/navigation";
import { Path, UserRole } from "../utilities/constants";

export default function GroupMembership({
  userId,
  isEditing,
  isComponentDisabled,
  openGroupPreview,
  showToastViewOnly,
  isUserViewOnly = false,
  loginUserType,
}) {
  const [myGroupDetails, setMyGroupDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loaderError, setError] = useState(false);

  useOnFirstLoad(() => {
    getMyGroups();
  });
  useEffect(() => {
    let timeoutId;

    if (loading) {
      // Set a timeout for 15 seconds
      timeoutId = setTimeout(() => {
        setLoading(false);
        setError(true);
      }, 15000);
    }

    // Cleanup the timeout on component unmount or when loading changes
    return () => clearTimeout(timeoutId);
  }, [loading]);

  function getMyGroups() {
    setError(false);
    try {
      if (userId) {
        SettingsApi.getUserGroupsById(userId).then((result) => {
          setMyGroupDetails(result?.groups);
          if (result?.success) {
            setLoading(false);
          } else {
            setError(true);
            setLoading(false);
          }
        });
      } else {
        SettingsApi.getUserGroups().then((result) => {
          setMyGroupDetails(result?.groups);
          if (result?.success) {
            setLoading(false);
          } else {
            setError(true);
            setLoading(false);
          }
        });
      }
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  }
  const onMsgClick = (item) => {
    openGroupPreview(item);
  };
  return (
    <div
      className={`my-groups-container ${loaderError && "loader-error"} ${
        (isComponentDisabled || isEditing) && "disabled"
      }`}
    >
      {loading && (
        <CircularProgress
          className="circular-progress--dashboard"
          label="Loading groups..."
        />
      )}
      {!loading && loaderError && (
        <span>Failed to load data, please try again later.</span>
      )}
      {!loading && !loaderError && (
        <>
          <div className="header">
            <span className="header-title">
              {myGroupDetails.length > 0
                ? "My Groups"
                : "You are Not in Any Groups"}
            </span>
          </div>
          {myGroupDetails?.length > 0 ? (
            <div className="groups-list">
              {myGroupDetails?.slice(0, 5).map((item, index) => (
                <>
                  <div
                    className="flex-wrap-row cursor-pointer"
                    key={index}
                    onClick={() => {
                      if (loginUserType !== UserRole.Member) {
                        onMsgClick(item);
                      }
                    }}
                    style={
                      loginUserType === UserRole.Member
                        ? {
                            pointerEvents: "none",
                            cursor: "not-allowed",
                          }
                        : {}
                    }
                  >
                    <div className="avatar my-groups-column col-1">
                      {item?.avatar ? (
                        <img src={item?.avatar} alt={`${item?.groupName}`} />
                      ) : (
                        <div className="initials">
                          {(() => {
                            const cleanName = (item?.groupName || "")
                              .replace(/[^a-zA-Z0-9\s]/g, "")
                              .replace(/\s+/g, " ")
                              .trim();

                            if (!cleanName) {
                              return (
                                <i className="fa fa-users users-avatar-group"></i>
                              );
                            }

                            const initials = cleanName
                              .split(" ")
                              .filter(Boolean)
                              .map((n) => n[0])
                              .slice(0, 2)
                              .join("")
                              .toUpperCase();

                            if (!initials) {
                              return (
                                <i className="fa fa-users users-avatar-group"></i>
                              ); // Fallback if no initials can be derived
                            }

                            return initials;
                          })()}
                        </div>
                      )}
                    </div>
                    {/* </div> */}
                    <div className="my-groups-column col-2 my-groups-group-name">
                      {item.groupName}
                    </div>
                    {/* Hide member count for members */}
                    {loginUserType !== UserRole.Member && (
                      <div className="my-groups-column col-3 my-groups-group-members">
                        {item.userGroupCount} Members
                      </div>
                    )}

                    <div className="my-groups-column col-4">
                      {item.description}
                    </div>
                  </div>
                  <div className="my-groups-divider"></div>
                </>
              ))}
            </div>
          ) : (
            <div
              className="groups-list"
              style={{
                height: 250,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              You have not been added to any groups. Once you are part of a
              group, it will be listed here
            </div>
          )}

          <div
            className="go-to-groups-btn"
            style={{
              ...(isUserViewOnly && { opacity: 0.6 }),
              ...(loginUserType === UserRole.Member && {
                pointerEvents: "none",
                cursor: "not-allowed",
                opacity: 0.6,
              }),
            }}
            onClick={() => {
              if (loginUserType === UserRole.Member) {
                return;
              }
              if (isUserViewOnly) {
                showToastViewOnly();
              } else {
                if (userId) {
                  navigate(Path.PeopleGroups.replace(":id", userId));
                } else {
                  navigate(Path.Groups);
                }
              }
            }}
          >
            Go to Groups
            <i className=" go-to-groups-icon far fa-chevron-right"></i>
          </div>
        </>
      )}
    </div>
  );
}
